<template>
  <ul
    :class="{
      'pb-6': hasPaddingBottom,
    }"
  >
    <li v-for="(item, idx) in items" :key="idx" class="max-w-4xl">
      <LazyBasketCardMobile
        v-if="isMobile"
        data-test-id="basket-card"
        :item="item"
        :index="idx"
        :class="areUnavailableItems && 'opacity-60'"
      />
      <LazyBasketCard
        v-else
        data-test-id="basket-card"
        :item="item"
        :index="idx"
        :class="areUnavailableItems && 'opacity-60'"
      />
    </li>
  </ul>
</template>

<script setup lang="ts">
import type { BasketItem } from '@scayle/storefront-nuxt'
import { useDeviceType } from '~/composables/useDeviceType'

defineProps<{
  items: BasketItem[]
  areUnavailableItems?: boolean
  hasPaddingBottom?: boolean
}>()

const { isMobile } = useDeviceType()
</script>
